import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks';
import { getSplitConfig, updateSplitConfig } from '@/services/credit-engine.service';
import { PARTNER_ID } from '@/constants';
import type { SplitConfigItem } from '@/types/policy.types';

const QUERY_KEY = ['policies', 'split', PARTNER_ID];

export function useSplit() {
  const queryClient = useQueryClient();
  const toast = useToast();

  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => getSplitConfig(PARTNER_ID),
  });

  const mutation = useMutation({
    mutationFn: (items: SplitConfigItem[]) =>
      updateSplitConfig({ partnerId: PARTNER_ID, items: JSON.parse(JSON.stringify(items)) }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QUERY_KEY });
      toast.success('Configuracion de split actualizada');
    },
    onError: () => {
      toast.error('Error al actualizar configuracion de split');
    },
  });

  return {
    split: query.data?.data ?? null,
    updateSplit: mutation.mutate,
    isSaving: mutation.isPending,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
